const awsConfig = {
  "aws_project_region": "ap-south-1",
  "aws_cognito_region": "ap-south-1",
  "aws_user_pools_id": "ap-south-1_GRQVD99ur",
  "aws_user_pools_web_client_id": "45rua209rto8tare4na7jhvmep",
  Auth: {
    region: "ap-south-1", // Change to your AWS region
    userPoolId: "ap-south-1_GRQVD99ur",
    userPoolWebClientId: "45rua209rto8tare4na7jhvmep",
    mandatorySignIn: true,
    authenticationFlowType: "USER_SRP_AUTH",
  }
};

export default awsConfig;